export const PERMISSION_CODES = {
  // Dashboard
  DASHBOARD_HOME_VIEW: 'DASHBOARD:HOME:VIEW',

  // Staffing Calendar
  STAFFING_CALENDAR_VIEW: 'MENU-AND-ORDERS:STAFFING-CALENDAR:VIEW',
  STAFFING_CALENDAR_SET: 'MENU-AND-ORDERS:STAFFING-CALENDAR:SET-STAFFING',
  STAFFING_CALENDAR_DELETE: 'MENU-AND-ORDERS:STAFFING-CALENDAR:DELETE-STAFFING',

  // Tasting Bookings
  TASTING_BOOKINGS_VIEW: 'MENU-AND-ORDERS:TASTING-BOOKINGS:VIEW',
  TASTING_BOOKINGS_BOOK: 'MENU-AND-ORDERS:TASTING-BOOKINGS:BOOK',
  TASTING_BOOKINGS_CANCEL: 'MENU-AND-ORDERS:TASTING-BOOKINGS:CANCEL',

  // Special Orders
  SPECIAL_ORDERS_VIEW: 'MENU-AND-ORDERS:COMPANY-SPECIAL-ORDERS:VIEW',
  SPECIAL_ORDERS_CREATE: 'MENU-AND-ORDERS:COMPANY-SPECIAL-ORDERS:CREATE',
  SPECIAL_ORDERS_EDIT: 'MENU-AND-ORDERS:COMPANY-SPECIAL-ORDERS:EDIT',

  // Employee Records
  EMPLOYEES_VIEW: 'PEOPLE:COMPANY-EMPLOYEES:VIEW',
  EMPLOYEES_SET_STATUS: 'PEOPLE:COMPANY-EMPLOYEES:SET-STATUS',

  // Reports
  SALES_STATISTICS_VIEW: 'REPORTS:COMPANY-SALES-STATISTICS:VIEW',

  // Vouchers
  VOUCHER_REQUESTS_VIEW: 'VOUCHERS:VOUCHER-REQUESTS:VIEW',
  VOUCHER_REQUESTS_CREATE: 'VOUCHERS:VOUCHER-REQUESTS:CREATE',
} as const;

export type PermissionCode =
  | (typeof PERMISSION_CODES)[keyof typeof PERMISSION_CODES]
  | string;
